import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";
import api from "../../api/api";
import { loginUser } from '../../reducers/userReducer';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment, IconButton } from "@mui/material";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [spinner, setSpinner] = useState(false);
  const [apiError, setApiError] = useState("");

  // State for loader and snackbar
  const [loading, setLoading] = useState(false); // Loader state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showPassword, setShowPassword] = useState(false);

  // Snackbar close handler
  const handleSnackbarClose = () => setSnackbarOpen(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const validate = () => {
    const newErrors = {};

    if (!userName) newErrors.userName = true;
    if (!password) newErrors.password = true;

    setErrors(newErrors);

    // Focus on the first invalid field
    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      document.getElementById(firstErrorField)?.focus();
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (event) => {
    
    event.preventDefault();

    if (!validate()) return; // Stop submission if validation fails
    setLoading(true); // Show loader
    setApiError(""); // Clear previous API errors

    const userCredentials = {
      userName,
      password
     
    };
    
    setSpinner(true);
    try {
      const response = await api.login(userCredentials);
      if (response.status === 200) {
        dispatch(loginUser({ user: response.data }));
        localStorage.setItem("token", response.data.token);
        setSnackbarMessage("Login successful!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        navigate("/home");
      } else {
 
        setSnackbarMessage("Login failed. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An unexpected error occurred.";
      setApiError(errorMessage);
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setSpinner(false);
      setLoading(false); 
    }
  };

  return (
    <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "90vh",
      backgroundColor: "#def1ff",
      // padding: "2rem",
    }}
  >
    

     <Box
  sx={{
    width: { xs: "90%", sm: "70%", md: "50%", lg: "35%" },
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    padding: { xs: "1.5rem", sm: "2rem" }, // smaller padding on mobile
  }}
>
      <Typography variant="h4" align="center" sx={{marginBottom:3}}>
        Login
      </Typography>
      {apiError && (
        <Typography color="error" align="center" sx={{ mb: 2 }}>
          {apiError}
        </Typography>
      )}

      <form onSubmit={handleLogin}>
        <Grid container spacing={2}>
          {/* Email Input */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Enter Email or MobileNumber"
              variant="outlined"
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              error={!!errors.userName}
              helperText={errors.userName}
              id="userName"
            />
          </Grid>

          {/* Password Input */}
          <Grid item xs={12}>
              <TextField
                fullWidth
                label="Password"
                variant="outlined"
                type={showPassword ? "text" : "password"} // toggle type
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={!!errors.password}
                helperText={errors.password}
                id="password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
 
            </Grid>

          {/* Remember Me and Forgot Password */}
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* <FormControlLabel
              control={<Checkbox name="rememberMe" />}
              label="Remember Me"
            /> */}
            {/* <Link to="#" style={{ textDecoration: "none", color: "#1976d2" }}>
              Forget Password
            </Link> */}
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} sx={{marginTop:2}}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              disabled={spinner}
            >
              {spinner ? <CircularProgress size={20} color="inherit" /> : "Login"}
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* Snackbar for Notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  </Box>
  );
};

export default Login;
